module.exports = __webpack_public_path__ + "img/dw.93a6336a.svg";